import React from 'react';
import PropTypes from 'prop-types';

const imageSrcFor = (post) => {
  const image = post.PreviewImage?.publicURL || post.FeaturedImage?.publicURL;
  return image.startsWith('/') || image.startsWith('https://') ? image : `/news/${post.slug}/${image}`;
};

const formatDate = (date) =>
  new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(date));

const NewsPostGrid = ({ newsPosts, id }) => {
  return (
    <ul className="news-posts" id={id}>
      {newsPosts.map((post) => (
        <li className="news-post__preview" key={post.slug}>
          <a href={`/news/${post.slug}/`}>
            <div className="news-post__preview-image-wrapper">
              <div
                className="news-post__preview-image"
                title={post.Title}
                style={{ backgroundImage: `url(${imageSrcFor(post)})` }}
              />
            </div>
            <p>{formatDate(post.Date)}</p>
            <h4>{post.PreviewTitle || post.Title}</h4>
          </a>
        </li>
      ))}
    </ul>
  );
};

NewsPostGrid.propTypes = {
  newsPosts: PropTypes.array,
  id: PropTypes.string
};

export default NewsPostGrid;
